import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import React, { useState } from 'react';

interface Props {
    onChange: any;
    label: string;
    style?: any;
    value?: string;
}
const PasswordInput: React.FC<Props> = ({ onChange, label, style, value }) => {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);

    return (
        <TextField
            value={value}
            style={style}
            label={label}
            variant="standard"
            type={showPassword ? "text" : "password"} // <-- This is where the magic happens
            onChange={onChange}
            InputProps={{ // <-- This is where the toggle button is added.
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                )
            }}
        />
    )
}

export default PasswordInput;